/**
 * Forecasting Components Index
 */

export { default as ForecastingDashboard } from './ForecastingDashboard';

// Placeholder components for sub-menu items
export const ForecastingPlaceholder = ({ title }) => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h2 style={{ color: '#666', marginBottom: '16px' }}>📉 {title}</h2>
    <p style={{ color: '#999' }}>This feature is coming soon.</p>
  </div>
);
